import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemText } from '@pulse/ui';
import { useState } from 'react';
import type { ReactNode } from 'react';

interface NavGroupHeaderProps {
  label: string;
  children: ReactNode;
  defaultExpanded?: boolean;
}

// Only rendered when the side nav itself is expanded — SideNav flattens a group's pages
// straight into the icon rail when collapsed, since a text header has no icon to show.
export function NavGroupHeader({ label, children, defaultExpanded = true }: NavGroupHeaderProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <>
      {/* Static sizing comes from theme.ts's MuiListItemButton override — nothing local needed. */}
      <ListItemButton onClick={() => setExpanded((prev) => !prev)}>
        <ListItemText
          primary={label}
          primaryTypographyProps={{ variant: 'caption', sx: { fontWeight: 600, opacity: 0.7 } }}
        />
        {expanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
      </ListItemButton>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List disablePadding>{children}</List>
      </Collapse>
    </>
  );
}
